import { createContext } from 'react';
import { AppConstantContextType } from './types';

export const AppConstantContext = createContext<AppConstantContextType>({
});

export const AppConstantProvider = AppConstantContext.Provider
